module.exports = __webpack_public_path__ + "static/media/C_E03.d50bb56e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_E03.png
// module id = 123
// module chunks = 0